var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoRef",staticClass:"video-js vjs-default-skin vjs-big-play-centered vjs-16-9",attrs:{"id":"videobox","preload":"auto","width":"100%","autoplay":"false"}},[_c('p',{staticClass:"vjs-no-js"},[_vm._v("不支持播放")])])])}
var staticRenderFns = []

export { render, staticRenderFns }